export default "__VITE_ASSET__D29$CBI3__"